/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormGroup } from "react-bootstrap-3";
import FieldErrorList from "./FieldErrorList";
import InputGroup from "./InputGroup";
import styled from "styled-components";
import TimezonePicker from "react-bootstrap-timezone-picker";

const SelectWrapper = styled.div`
  display: flex;
`;

const StyledFormControl = styled(FormControl)`
  max-width: 150px !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
`;

const StyledTimezonePicker = styled(TimezonePicker)`
  display: flex;
  // faux dropdown arrows
  & input {
    cursor: pointer;
  }

  :after {
    content: "";
    border: solid ${({ theme }) => theme.regularTextColor};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    height: 8px;
    width: 8px;
    margin-left: -20px;
    z-index: 2;
    margin-top: 10px;
  }
`;
function CancellationRange({
  errors,
  value,
  hasErrors,
  onChange,
  field,
  additionalFields,
  className,
}) {
  const { fieldName, optionDisplayFirst, optionDisplaySecond, disabled, defaultValue } = field;
  const valuesToShowHoursSelector = [0, 1, 2, 3];
  return (
    <div className={`CancellationRange ${field.className}${className}`}>
      <FormGroup>
        <SelectWrapper>
          <FormControl
            defaultValue={defaultValue}
            disabled={disabled}
            value={value.days}
            name={`${fieldName}days`}
            componentClass="select"
            className={`form-control ${hasErrors && "parsley-error"}`}
            onChange={event =>
              onChange({
                value: { ...value, days: event.target.value },
                field: fieldName,
              })
            }>
            {Object.keys(optionDisplayFirst).map(key => (
              <option value={key} key={key}>
                {optionDisplayFirst[key].label}
              </option>
            ))}
          </FormControl>
          {valuesToShowHoursSelector.includes(Number(value.days)) && (
            <>
              <StyledFormControl
                disabled={value.days === "" || value.days === undefined || value.days === null}
                value={value.hours}
                name={`${fieldName}hours`}
                componentClass="select"
                className={`form-control ${hasErrors && "parsley-error"}`}
                onChange={event =>
                  onChange({
                    value: { ...value, hours: event.target.value },
                    field: fieldName,
                  })
                }>
                {Object.keys(optionDisplaySecond).map(key => (
                  <option value={key} key={key}>
                    {optionDisplaySecond[key].label}
                  </option>
                ))}
              </StyledFormControl>
              <StyledTimezonePicker
                disabled={value.days === "" || undefined || null}
                defaultValue={value.timeZone || "Europe/Madrid"}
                placeholder="Select timezone..."
                onChange={timeZone =>
                  onChange({
                    value: { ...value, timeZone: timeZone },
                    field: fieldName,
                  })
                }
              />
            </>
          )}
        </SelectWrapper>
        {additionalFields &&
          additionalFields.map(additionalField => {
            if (additionalField.isVisible) {
              // Created a switch for a future implementations,
              // additionalField could be select, checkbox...
              switch (additionalField.type) {
                default:
                  return (
                    <>
                      <InputGroup
                        disabled={disabled}
                        value={additionalField.value}
                        field={additionalField.field}
                        onChange={additionalField.onChange}
                      />
                      {additionalField.errors && <FieldErrorList errors={additionalField.errors} />}
                    </>
                  );
              }
            } else {
              return null;
            }
          })}
      </FormGroup>
    </div>
  );
}

CancellationRange.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CancellationRange;
